import styled from 'styled-components'
import Button from '@components/Button'

/* Never shrinks beside a long title. */
export const BackLinkButton = styled(Button)`
	flex-shrink: 0;
`
